import * as axios from "axios";

export interface RylzTalkbackInfo {
    count?: number
    blocked: boolean
}

const talkbackCache: { [articleId: string]: RylzTalkbackInfo } = {};
const talkbackInflight: { [articleId: string]: Promise<RylzTalkbackInfo> } = {};

export function getCachedRylzTalkback(articleId: string): RylzTalkbackInfo | undefined {
    return talkbackCache[articleId];
}

/** Fetches once per articleId for the page lifetime; reuses cache / in-flight promise. */
export function loadRylzTalkback(articleId: string): Promise<RylzTalkbackInfo> {
    const cached = talkbackCache[articleId];
    if (cached) return Promise.resolve(cached);

    const inflight = talkbackInflight[articleId];
    if (inflight) return inflight;

    const request = axios.get(`/iphone/json/api/talkbacks/list/v2/${articleId}/start_to_end/0`)
        .then((res: any) => {
            const channel = res.data && res.data.rss && res.data.rss.channel;
            const info: RylzTalkbackInfo = channel
                ? {
                    blocked: channel.talkbacks_closed === 1 || channel.talkbacksClosed === 1,
                    count: channel.sum_talkbacks,
                }
                : { blocked: false };
            talkbackCache[articleId] = info;
            return info;
        })
        .catch(() => ({ blocked: false } as RylzTalkbackInfo))
        .then((info) => {
            delete talkbackInflight[articleId];
            return info;
        });

    talkbackInflight[articleId] = request;
    return request;
}
